import { render, staticRenderFns } from "./ProductCategoryView.vue?vue&type=template&id=2b6cfedc&"
import script from "./ProductCategoryView.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryView.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports